import { Injectable } from '@angular/core'
import { map, Observable } from 'rxjs'
import {
  AddSelfReportGQL,
  GetHighScoreListGQL,
  GetHighScoreListQuery,
  GetSelfReportsGQL,
  GetSelfReportsQuery,
  SelfReportType,
  Strands,
  UserScoreDetailsFragment,
} from '../../../../../generated/graphql'
import { ArrayElement } from '../../../typescript'

export type SelfReportDetails = ArrayElement<GetSelfReportsQuery['getAccountById']['selfReports']>
export type HighScoreEntry = ArrayElement<GetHighScoreListQuery['getHighScoreList']>
export type UserScoreDetails = UserScoreDetailsFragment

export const selfReportIcons = [
  {
    url: 'assets/images/self-reports/watchlisten.png',
    type: SelfReportType.WatchListen,
    text: 'Watch / Listen',
  },
  {
    url: 'assets/images/self-reports/read.png',
    type: SelfReportType.Read,
    text: 'Read',
  },
  {
    url: 'assets/images/self-reports/do.png',
    type: SelfReportType.Do,
    text: 'Do',
  },
  {
    url: 'assets/images/self-reports/visitattend.png',
    type: SelfReportType.VisitAttend,
    text: 'Visit / Attend',
  },
]

export interface SelfReportResults {
  selfReports: SelfReportDetails[]
  userScoreDetails: UserScoreDetails
}

@Injectable({
  providedIn: 'root',
})
export class SelfReportService {
  constructor(
    private getSelfReportsGQL: GetSelfReportsGQL,
    private addSelfReportGQL: AddSelfReportGQL,
    private getHighScoreListGQL: GetHighScoreListGQL,
  ) {}

  public getSelfReports(accountId: string): Observable<SelfReportResults> {
    return this.getSelfReportsGQL
      .fetch(
        {
          id: accountId,
        },
        {
          fetchPolicy: 'network-only',
        },
      )
      .pipe(
        map((result) => {
          // return result.data.getAccountById.selfReports
          const selfReports = result.data.getAccountById.selfReports
          const userScoreDetails: UserScoreDetails = {
            _id: result.data.getAccountById._id,
            currentStreak: result.data.getAccountById.score.currentStreak,
            longestStreak: result.data.getAccountById.score.longestStreak,
            totalScore: result.data.getAccountById.selfReportIds.length,
            loginName: result.data.getAccountById.loginName,
          }
          // console.log(result, selfReports)
          return { selfReports, userScoreDetails }
        }),
      )
  }

  public addSelfReport(
    accountId: string,
    title: string,
    description: string,
    materialUrl: string,
    strands: Strands,
    type: SelfReportType,
    contentElementId?: string,
  ) /*: Observable<SelfReportDetails[]>*/ {
    return this.addSelfReportGQL
      .mutate(
        {
          id: accountId,
          title,
          description: description,
          materialUrl: materialUrl,
          strands: strands,
          type: type,
          contentElementId: contentElementId,
        },
        {
          fetchPolicy: 'network-only',
        },
      )
      .pipe(
        map((result) => {
          return result.data?.addSelfReportToAccount
        }),
      )
  }

  public getHighScoreList(nrOfAccounts: number, sortBy: string): Observable<HighScoreEntry[]> {
    return this.getHighScoreListGQL
      .fetch(
        {
          nrOfAccounts,
          sortBy,
        },
        {
          fetchPolicy: 'network-only',
        },
      )
      .pipe(
        map((result) => {
          return result.data.getHighScoreList
        }),
      )
  }

  public getIconFromSelfReportType(type: SelfReportType): string {
    switch (type) {
      case SelfReportType.WatchListen:
        return selfReportIcons[0].url
      case SelfReportType.Read:
        return selfReportIcons[1].url
      case SelfReportType.Do:
        return selfReportIcons[2].url
      case SelfReportType.VisitAttend:
        return selfReportIcons[3].url
      default:
        return selfReportIcons[0].url
    }
  }

  public getTextFromSelfReportType(type: SelfReportType): string {
    switch (type) {
      case SelfReportType.WatchListen:
        return selfReportIcons[0].text
      case SelfReportType.Read:
        return selfReportIcons[1].text
      case SelfReportType.Do:
        return selfReportIcons[2].text
      case SelfReportType.VisitAttend:
        return selfReportIcons[3].text
      default:
        return selfReportIcons[0].text
    }
  }
}
